<section id="dacPastEven-id" class="dac-vdo-event">
  <div class="box">
    <div class="box-content">
      <div class="box-content__title">
        <span>{{ 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.VOD_EVENT.TITLE' | translate }}</span>
      </div>
      <div class="box-content__detail">
        <span>{{ 'EVENT.DIGITAL_ACCOUNTING_CONFERENCE.VOD_EVENT.DETAIL' | translate }}</span>
      </div>
    </div>

    <div class="box-vdo">
      <div class="box-vdo__element" *ngFor="let item of videoList">
        <div class="box-vdo__element--show" (click)="linkVideo(item.videoId)">
          <picture>
            <source
              [srcset]="
                'https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/vdo-event/v2/' +
                item.imageBaseName +
                '.webp'
              "
              type="image/webp"
            />
            <img
              [src]="
                'https://flowaccountcdn.com/new_landing/image/event/digital-accounting-conference/vdo-event/v2/' +
                item.imageBaseName +
                '.png'
              "
              [alt]="item.imageBaseName"
              loading="lazy"
            />
          </picture>
          <div class="show-icon">
            <img
              src="https://flowaccountcdn.com/new_landing/icon/play_button_fb.png"
              class="show-icon__play"
              alt="play_button_fb"
            />
          </div>
        </div>
        <div class="box-vdo__element--text">
          <span>{{ item.textKey | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</section>
